import { connect } from "react-redux";
import { selectClient, getClientInfo } from "../../actions/App";
import { getClientSites } from "../../actions/Clients";
import {
  setReportWebSiteId,
  setReportDayRange,
  getInsightsMostPopularPages,
  getFavoritePages,
  setPageFavorite,
} from "../../actions/Insights";
import PopularPagesIndex from "../../components/Insights/page/PopularPages";
const mapStateToProps = state => {
  const {
    websiteId,
    dayRange,
    mostPopularPages,
    loadingPopularPages,
    loadingPopularPagesError,
    favoriting,
    setFavoriteError,
  } = state.insights;
  const { client_sites } = state.clients;
  const { selected_client, clients, client_info } = state.app;
  return {
    websiteId,
    client_info,
    client_sites,
    selected_client,
    clients,
    dayRange,
    location: state.routing.location,
    mostPopularPages,
    loadingPopularPages,
    loadingPopularPagesError,
    favoriting,
    setFavoriteError,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    getClientInfo: cid => {
      dispatch(getClientInfo(cid));
    },
    setDateRange: str => {
      dispatch(setReportDayRange(str));
    },

    getClientSites: cid => {
      dispatch(getClientSites(cid, true));
    },

    setWebsiteId: id => {
      dispatch(setReportWebSiteId(id));
    },

    selectClient: clientId => {
      dispatch(selectClient(clientId));
    },

    fetchMostPopularPages: (tagId, dateRange) => {
      dispatch(getInsightsMostPopularPages(tagId, dateRange));
    },

    fetchFavoritePages: tagId => {
      dispatch(getFavoritePages(tagId));
    },

    setPageFavorite: (tagId, dateRange, pageUrl, favorited) => {
      dispatch(setPageFavorite(tagId, dateRange, pageUrl, favorited));
    },
  };
};

const PopularPagesContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PopularPagesIndex);

export default PopularPagesContainer;



// WEBPACK FOOTER //
// ./src/containers/Insights/PopularPages.js